import React, { useEffect } from 'react';

interface FormObserverProps {
  isValid: boolean;
  submitCount: number;
}

const FormObserver: React.FC<FormObserverProps> = ({ isValid, submitCount }) => {
  useEffect(() => {
    if (submitCount > 0 && !isValid) {
      const errorElement = document.querySelector('.error-message');
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [submitCount, isValid]);
  return null;
};

export default FormObserver;
